import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=5ff876a5&scoped=true&"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=5ff876a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff876a5",
  null
  
)

export default component.exports